export const columns1 = [
  {
    id: 'pictureasin',
    title: '图片',
    field: 'imageUrl',
    fixed: 'left',
    width: '100px',
    slots: {
      default: 'image'
    },
    default: true,
    disabled: true,
    // treeNode: true,
  },
  {
    id: 'listingInfo',
    field: 'listingInfo',
    fixed: 'left',
    width: '130px',
    slots: {
      default: 'listingInfo',
      // header:'listingInfo-header'
    },
    default: true,
    disabled: true,
    sortable: true,
    sortBy:''
  },
  {
    id: 'asins',
    title: 'ASIN分析',
    field: 'asins',
    width: '100px',
    fixed: 'left',
    slots: {
      default: 'asins'
    },
    default: true,
    disabled: true,
    visible: true
  },
  {
    id: 'marketId',
    title: '店铺/国家',
    field: 'listingMarketName',
    width: '120px',
    fixed: 'left',
    slots: {
      default: 'listingMarketName'
    },
    default: true,
    disabled: true
  },
  {
    id: 'asin',
    title: 'ASIN',
    field: 'asin',
    width: '130px',
    default: true,
    visible: true,
    sortable: true
  },
  {
    id: 'parentAsin',
    title: '父ASIN',
    field: 'variationAsin',
    width: '140px',
    slots: {
      default: 'variationAsin'
    },
    default: true,
    visible: true,
    sortable: true
  },
  {
    id: 'product',
    title: '产品名称/SKU',
    field: 'product',
    width: '180px',
    slots: {
      default: 'product'
    },
    default: true,
    visible:true,
    disabled: false,
    sortable: true,
    sortBy: 'sku'
  },
  {
    id: 'fulfillableQuantity',
    title: 'FBA可售',
    titleHelp: {
      message: "当前FBA仓库可售量"
    },
    field: 'fulfillableQuantity',
    slots: {
      default: 'fulfillableQuantity'
    },
    summary: true,
    align: 'right',
    minWidth: '120px',
    default: true
  },
  {
    id: 'saleableTurnover',
    title: 'FBA可售周转',
    titleHelp: {
      message: "FBA可售周转=FBA可售/7天日均销量"
    },
    field: 'saleableTurnover',
    slots: {
      default: "saleableTurnover"
    },
    summary: true,
    align: 'right',
    minWidth: '120px',
    default: true
  },
  {
    id: 'fulfillableQuantityFBM',
    title: 'FBM可售',
    titleHelp: {
      message: '当前FBM仓库可售量'
    },
    field: 'fulfillableQuantityFBM',
    slots: {
      default: 'fulfillableQuantityFBM'
    },
    summary: true,
    align: 'right',
    minWidth: '100px',
    default: true
  },
  {
    id: 'saleableTurnoverFBM',
    title: 'FBM可售周转',
    titleHelp: {
      message: 'FBM可售周转=FBM可售/7天日均销量'
    },
    field: 'saleableTurnoverFBM',
    slots: {
      default: 'saleableTurnoverFBM'
    },
    summary: true,
    align: 'right',
    minWidth: '120px',
    default: true
  },
  {
    id: 'crawlTitle',
    title: '商品标题',
    field: 'crawlTitle',
    width: '160px',
    sortable: false,
    default: false,
    slots: {
      default: 'crawlTitle',
    }
  },
  {
    id: 'categoryName',
    title: '品类',
    field: 'categoryName',
    width: '140px',
    sortable: false,
    default: false,
    slots: {
      default: 'categoryName',
    }
  },
  {
    id: 'brandName',
    title: '品牌',
    field: 'brandName',
    width: '140px',
    sortable: false,
    default: false,
    slots: {
      default: 'brandName',
    }
  },
  {
    id: 'sellingManagerNames',
    title: '负责人',
    field: 'sellingManagerNames',
    width: '140px',
    sortable: false,
    default: false,
    slots: {
      default: 'sellingManagerNames',
    }
  },

]
